import { useMemo } from "react";
import { TextShimmer } from "../ui/text-shimmer";

export const AGENT_THINKING_LABELS = [
  "Working...",
  "Reasoning...",
  "Preparing response...",
  "Reviewing context...",
  "Looking into it...",
  "Connecting the dots...",
  "Planning next steps...",
  "Checking sources...",
  "Running tools...",
  "Analyzing...",
] as const;

function pickRandomThinkingLabel(): string {
  const index = Math.floor(Math.random() * AGENT_THINKING_LABELS.length);
  return AGENT_THINKING_LABELS[index] ?? AGENT_THINKING_LABELS[0];
}

export function ThinkingLabel({ className }: { className?: string }) {
  const label = useMemo(() => pickRandomThinkingLabel(), []);

  return (
    <TextShimmer className={className} duration={1.8} spread={22}>
      {label}
    </TextShimmer>
  );
}
